import Cookies from 'js-cookie';
import { message } from 'antd';

// 请求重复过滤
export var requestSet = new Set();
export var CommonRequest = {
  success: function success(config) {
    var _config$delayTime = config.delayTime,
      delayTime = _config$delayTime === void 0 ? 1000 * 80 : _config$delayTime;

    // 修改请求超时时间
    config.timeout = delayTime;
    var sid = window.localStorage.getItem('sid');
    var TOKEN = "token".concat(sid);
    var SELECT_ORG_CODE = "selectOrgCode".concat(sid);

    // 请求头添加token
    if (Cookies.get(TOKEN) && config.headers) {
      config.headers.Authorization = Cookies.get(TOKEN);
    }
    if (ALIAS_ENV !== 'global') {
      config.headers['X-Site-Alias'] = ALIAS_ENV;
      if (Number(sid) === 1) {
        config.headers['X-Site-Alias'] = 'merchant';
      }
    }

    // 接口请求增加org
    var selectOrgCode = Cookies.get(SELECT_ORG_CODE);
    if (selectOrgCode) {
      config.headers['X-Site-Org'] = selectOrgCode;
    }
    return config;
  },
  error: function error() {
    // 请求错误处理
    message.error('系统繁忙，请稍后再试');
    return Promise.reject('系统繁忙，请稍后再试');
  }
};
export var ExamRequest = {
  success: function success(config) {
    CommonRequest.success(config);
    // 定制考试业务的request拦截器
    return config;
  },
  error: function error() {
    CommonRequest.error();
    // 定制考试业务的request拦截器
  }
};